import { SafeBatchTransferFrom } from './actions/SafeBatchTransferFrom';
import { SafeTransferFrom } from './actions/SafeTransferFrom';
import { SetApprovalForAll } from './actions/SetApprovalForAll';
import { BalanceOf } from './getters/BalanceOf';
import { IsApprovedForAll } from './getters/IsApprovedForAll';
import { SupportsInterface } from './getters/SupportsInterface';
import { Uri } from './getters/Uri';
var actions = {
    SafeBatchTransferFrom: SafeBatchTransferFrom,
    SafeTransferFrom: SafeTransferFrom,
    SetApprovalForAll: SetApprovalForAll,
};
var getters = {
    BalanceOf: BalanceOf,
    IsApprovedForAll: IsApprovedForAll,
    SupportsInterface: SupportsInterface,
    Uri: Uri,
};
var ERC1155 = {
    actions: actions,
    getters: getters,
};
export { ERC1155 };
